export interface IAlarmData {
  type?: string;
  threshold_ON?: number;
  excess_value_ON?: number;
  threshold_OFF?: number;
  excess_value_OFF?: number;
  active?: boolean;
  timestamp_ON?: number | string;
  timestamp_OFF?: number | string;
  [key: string]: any;
}

export class AlarmDTO {
  readonly type: string;
  readonly thresholdOn: number | null;
  readonly valueOn: number | null;
  readonly thresholdOff: number | null;
  readonly valueOff: number | null;
  readonly active: boolean;
  readonly start: number | string | null;
  readonly end: number | string | null;

  constructor(data: IAlarmData) {
    this.type = String(data.type || 'unknown');
    this.thresholdOn = data.threshold_ON ?? null;
    this.valueOn = data.excess_value_ON ?? null;
    this.thresholdOff = data.threshold_OFF ?? null;
    this.valueOff = data.excess_value_OFF ?? null;
    this.active = Boolean(data.active);
    this.start = data.timestamp_ON ?? null;
    this.end = data.timestamp_OFF ?? null;
  }

  static fromApiResponse(api: IAlarmData): AlarmDTO {
    return new AlarmDTO(api);
  }

  static fromApiResponseArray(arr: any): AlarmDTO[] {
    if (!Array.isArray(arr)) return [];
    return arr.map((a) => AlarmDTO.fromApiResponse(a));
  }
}


